import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { CountryListResponseData } from "../../types/enum";

export const getData = async () => {
  const { data } = await api.get<CountryListResponseData>(`/countries`);

  return data;
};

export const useCountries =
  (): QueryObserverBaseResult<CountryListResponseData> => {
    const { data, ...props } = useQuery(queryKeys.countries(), () => getData());

    return { data, ...props };
  };
